export const initialState = {
  dialog: false,
  popover: false
}


// WEBPACK FOOTER //
// ./src/interface/store/departments/layers/selectors.js